<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4start#chap1">1 The Continuing Legend of J. Chesthair</a></p>
<p class="toc1"><a href="#/5chap2#chap2">2 Her Satanic Majesty</a></p>
<p class="toc1"><a href="#/6chap3#chap3">3 Gangin’ Up</a></p>
<p class="toc1"><span href="#/7chap4#chap4" title="Link target outside of Sample">4 The Aquamarine Door</span></p>
<p class="toc1"><span href="#/8chap5#chap5" title="Link target outside of Sample">5 Guerrilla Girlfriend</span></p>
<p class="toc1"><span href="#/9chap6#chap6" title="Link target outside of Sample">6 Bring ’em Back Alive … or Not</span></p>
<p class="toc1"><span href="#/10chap7#chap7" title="Link target outside of Sample">7 Get with the Program</span></p>
<p class="toc1"><span href="#/11chap8#chap8" title="Link target outside of Sample">8 Cecil’s Dream</span></p>
<p class="toc1"><span href="#/12chap9#chap9" title="Link target outside of Sample">9 Steven’s Dream</span></p>
<p class="toc1"><span href="#/13chap10#chap10" title="Link target outside of Sample">10 The Sweet Smell of Victory</span></p>
<p class="toc1"><span href="#/14chap11#chap11" title="Link target outside of Sample">11 Our Nuke-u-lar Family</span></p>
<p class="toc1"><span href="#/15biography#biography" title="Link target outside of Sample">A Biography of Chris Lynch</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?3acbf9c3